import { render, staticRenderFns } from "./WashroomRepairQuote.vue?vue&type=template&id=60f13181&scoped=true&"
import script from "./WashroomRepairQuote.vue?vue&type=script&lang=js&"
export * from "./WashroomRepairQuote.vue?vue&type=script&lang=js&"
import style0 from "./WashroomRepairQuote.vue?vue&type=style&index=0&id=60f13181&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f13181",
  null
  
)

export default component.exports